import { tagId } from '../fixture-ids';

export const tagLegacyAlternates = {};

export const tagLegacyFixtures = {
  // The id-less case: no tagId, no join-row id, and no parentNameKeys is
  // declared for a bare tag either -- unlike consentCategory, `tag` has no scoped view of its own
  // in this epic. Degrades to keyValue, unattributed with reason identityUnresolved.
  PIPELINE_TAG_CREATED: { action: 'PIPELINE_TAG_CREATED', debugData: { tagLabel: 'production' } },
  PIPELINE_TAG_UPDATED: { action: 'PIPELINE_TAG_UPDATED', debugData: { tagId, tagLabel: 'production' } },
  PIPELINE_TAG_DELETED: { action: 'PIPELINE_TAG_DELETED', debugData: { tagId, tagLabel: 'production' } },
};
